module.exports = "/images/steph.png?cb0c81d2a76aa22fd40b1c258dd77fa2";